export default __webpack_public_path__ + "static/media/1277.77019f9a.png";